"use strict";
/**
 * Custom-field type definitions (Plan 45 §1).
 *
 * Templates declare per-eventType field-defs in `clientData.hdsCustomField[<eventType>]`
 * on each provisioned stream. The validator walks the parent chain (§2.4) — an empty
 * `{}` def on a descendant stream is the explicit opt-out marker.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyDef = isEmptyDef;
/** True when a value is the empty-object opt-out marker. */
function isEmptyDef(v) {
    return v != null && typeof v === 'object' && Object.keys(v).length === 0;
}
